import { getItemIdentifier } from 'utils/slug';
import { Anchor } from './anchors';
import { IBlogPost, INews } from './types';

export const RTPI_UTM =
  '?utm_source=rtpiinfo&utm_medium=contactus&utm_campaign=rtpiinfo';

export const Routes = {
  notFound: '/notFound',
  home: '/',
  terms: '/terms',
  search: '/search',
  login: '/login',
  cookie: '/cookie',
  privacy: '/privacy',
  aboutUs: '/about-us',
  register: '/register',
  providers: '/slots/providers',
  responsibleGaming: '/responsible-gaming',
  contactUs: `/about-us#${Anchor.ContactUs}`,

  aboutThisAuthor: (id: string) =>
    `/about-us/${id?.replaceAll(' ', '-')?.toLocaleLowerCase()}`,

  provider: (id: string) => `/slots/providers/${id}`,

  publicProfile: (id: string) => `/public-profile/${id}`,
  profile: `/profile`,

  blogAndNews: '/blog-and-news',
  guides: '/guides',
  news: '/news',
  guidesCasinos: '/guides/casinos',
  guidesSlots: '/guides/slots',
  guidesRtpChecks: '/guides/rtpchecks',
  guidesOther: '/guides/other',

  blogAndNewsCategory: (category: string) => `/blog-and-news/${category}`,
  blogAndNewsPage: (id: string) => `/post/${id}`,
  guidePage: (id: string) => `/guide/${id}`,

  dynamicBlogPage: function (data: IBlogPost | INews | undefined) {
    if (!data) {
      return this.guides;
    }

    const id = getItemIdentifier(data);

    return data?.type === 'guide'
      ? this.guidePage(id)
      : this.blogAndNewsPage(id);
  },

  allCasinos: `/casinos/`,
  casinoPage: (id: string) =>
    id && id !== 'null' ? `/casinos/${id}` : '/casinos/',
  casinoSlotReviewsPage: (id: string) =>
    id && id !== 'null' ? `/casinos/${id}/slot-reviews` : '/casinos/',
  casinoBigWinsPage: (id: string) =>
    id && id !== 'null' ? `/casinos/${id}/big-wins` : '/casinos/',
  casinoCollections: (name: string) => `/casinos/collections/${name}`,

  allSlots: `/slots/`,
  slotPage: (id: string) => `/slots/${id}`,
  slotRtpReviewsPage: (id: string) => `/slots/${id}/rtp-reviews`,
  slotForRealMoneyPage: (id: string) => `/slots/${id}/for-real-money`,
  slotBigWinsPage: (id: string) => `/slots/${id}/big-wins`,
  slotCollections: (name: string) => `/slots/collections/${name}`,

  streamers: '/streamers',
  streamersAll: `/streamers/all`,
  streamer: (id: string) => `/streamers/${id}`,
  streamersCollections: (name: string) => `/streamers/collections/${name}`,

  complaints: '/casino-complaints/',
  complaint: (id: string) => `/casino-complaints/${id}`,

  questions: '/questions',
  question: (id: string) => `/questions/${id}`,

  bigwins: '/big-wins',
  bigwin: (id: string) => `/big-wins/${id}`,
};
